import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../api/axios';
import '../gral-stylesheets/register.scss';

const registerURL = '/register';



const RegisterForm = (props) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailChange, setEmailChange] = useState(false);
  const [passwordChange, setPasswordChange] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();


    let formData = { email, password };
    let axiosConfiguration = {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    }

    await axios
      .post(
        registerURL,
        formData,
        axiosConfiguration
      )
      .then(() => {
        setEmail('');
        setPassword('');
        props.successOpen();
        props.joinClose();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  if (!props.joinState) {
    return null
  }
  return (
    <>
      <form
        className='register-form'
        onSubmit={handleSubmit}
      >
        <div className='input-container'>
          <label htmlFor='email'>
            <h5
              className={
                emailChange ?
                  'input-label up' :
                  email !== '' ?
                    'input-label up' : 'input-label'
              }
            >
              Email
            </h5>
          </label>
          <input
            type='email'
            id='email'
            name='email'
            className='input-register'
            required
            value={email}

            aria-invalid='false'
            aria-describedby="email-note"

            onFocus={() => { setEmailChange(true) }}
            onBlur={(e) => { setEmailChange(false) }}
            onChange={(e) => { setEmail(e.target.value) }}
          />
          <div
            id="email-note"
            className='display-none'
          >
            Ingress valid email.<br />
            Must begin with a letter.
          </div>
        </div>
        <div className='input-container'>
          <label htmlFor='password'>
            <h5
              className={
                passwordChange ?
                  'input-label up' :
                  password !== '' ?
                    'input-label up' : 'input-label'
              }
            >
              Password
            </h5>
          </label>
          <input
            type='password'
            id='password'
            name='password'
            className='input-register'
            required
            value={password}

            aria-invalid='false'
            aria-describedby="pwdnote"

            onFocus={() => { setPasswordChange(true) }}
            onBlur={(e) => { setPasswordChange(false) }}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div
            id="pwdnote"
            className='display-none'
          >

            8 to 24 characters.<br />
            Must include uppercase and lowercase letters, a number and a special character.<br />
            Allowed special characters:
            <span aria-label="exclamation mark">!</span>
            <span aria-label="at symbol">@</span>
            <span aria-label="hashtag">#</span>
            <span aria-label="dollar sign">$</span>
            <span aria-label="percent">%</span>
          </div>
        </div>
        <div className='input-container'>
          <button
            type='submit'
          >
            <h4>Create account</h4>
          </button>
        </div>
        <div className='input-container'>
          <div className='terms-privacy-policy'>
            <h4>By clicking</h4>
            <h4><strong>Create Account</strong></h4>
            <h4>, you agree to our</h4>
            <Link to='/register'>Terms</Link>
            <h4>and have read and acknowledge our</h4>
            <Link to='/register'>Global Privacy Statement.</Link>
          </div>
        </div>
      </form>
      <div className='register-login'>
        <h3>Already registered?</h3>
        <p
          onClick={props.toLogin}
        >
          Login here
        </p>
      </div>
    </>
  )
}

export default RegisterForm;